
import React from 'react';
import styled from 'styled-components';
// // import * as _ from 'lodash';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';


const SpinnerContainer = styled.div`
  margin: 100px auto;
  //width: 50px;
  height: 40px;
  text-align: center;
  font-size: 10px;
`;

export default class BaseDataTableContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      dataList: [],
    };
    this.mounted = true;
  }
  

  renderSpinnerNodata = () => {
    return (
      <SpinnerContainer>
        <h2>No Data</h2>
      </SpinnerContainer>
    );
  };

  render() {
    return (
      <BootstrapTable
        keyField='_id'
        data={this.props.dataList}
        columns={this.props.columns}
        // striped
        hover
        // remote
        pagination={paginationFactory()}
        // onTableChange={this.onPageChange}
        noDataIndication={this.renderSpinnerNodata}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/BaseContainer/BaseDataTableContainer.js